var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.mobile ? 'router-link router-link-mobile' : 'router-link router-link-desktop',attrs:{"to":_vm.to}},[_vm._v("\n    \n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }